import React from "react";
import useStyles from "../styles/styles";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import bookRide from "../assets/img/book-ride-img.webp";

const Section = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={`${classes.bookaRideSection} ${classes.spacings}`}>
      <div className={classes.sectionImageContainer}>
        <img
          className={classes.sectionContainerImage}
          src={bookRide}
          alt="home"
        />
      </div>

      <div className={classes.bookRideTextContainer}>
        <h2 className={classes.h2SectionContainer}>{t(`noapp`)} </h2>
        <h2 className={classes.h2SectionContainer}>{t(`bookyourride`)} </h2>

        <p className={classes.p1SectionContainer}>{t(`donthavephone`)}</p>
        <Link
          className={`${classes.buttonSectionContainer} ${classes.primaryBtn}`}
          to="/login"
        >
          {t(`visitweb`)}
        </Link>
      </div>
    </div>
  );
};

export default Section;
